import cloneDeep from 'lodash.clonedeep'
import axiosRatingEngine from '@/services/axiosRatingEngine'

const components = {
  'CommercialCombined\\GeneralLiability': () =>
    import(`@/content/products/rates/CommercialCombined/GeneralLiability.vue`), // CommercialCombined\\GeneralLiability
  'CommercialCombined\\OfficeCover': () => import(`@/content/products/rates/CommercialCombined/OfficeCover.vue`), // CommercialCombined\\OfficeCover
  'AvivaCommercialCombined\\GeneralLiability': () =>
    import(`@/content/products/rates/AvivaCommercialCombined/GeneralLiability.vue`), // AvivaCommercialCombined\\GeneralLiability
  'AvivaCommercialCombined\\OfficeCover': () =>
    import(`@/content/products/rates/AvivaCommercialCombined/OfficeCover.vue`), // AvivaCommercialCombined\\OfficeCover
  'ProfessionalIndemnity\\ProfessionalIndemnity': () => import(`@/content/products/rates/ProfessionalIndemnity.vue`), // ProfessionalIndemnity\\ProfessionalIndemnity
  'CyberSecurity\\CyberSecurity': () => import(`@/content/products/rates/CyberSecurity.vue`), // CyberSecurity\\CyberSecurity"
  'ManagementLiability\\DirectorsAndOfficers': () => import(`@/content/products/rates/DirectorsAndOfficers.vue`), // ManagementLiability\\DirectorsAndOfficers
  'ManagementLiability\\EmploymentPracticesLiability': () =>
    import(`@/content/products/rates/EmploymentPracticesLiability.vue`), // ManagementLiability\\EmploymentPracticesLiability
  'ManagementLiability\\Crime': () => import(`@/content/products/rates/Crime.vue`), // ManagementLiability\\Crime
  'LegalExpenses\\LegalExpenses': () => import(`@/content/products/rates/LegalExpenses.vue`), // LegalExpenses\\LegalExpenses
  'HealthcareProfessional\\HealthcareProfessional': () => import(`@/content/products/rates/HealthcareProfessional.vue`), // HealthcareProfessional\\HealthcareProfessional
  'ProfessionalInsurance\\CyberSecurity': () =>
    import(`@/content/products/rates/ProfessionalInsurance/CyberSecurity.vue`), // ProfessionalInsurance\\CyberSecurity
  'ProfessionalInsurance\\ProfessionalIndemnity': () =>
    import(`@/content/products/rates/ProfessionalInsurance/ProfessionalIndemnity.vue`), // ProfessionalInsurance\\ProfessionalIndemnity
  'CommercialCombined\\AppearHere': () => import(`@/content/products/rates/CommercialCombined/AppearHere.vue`), // CommercialCombined\\AppearHere
}

export default {
  computed: {
    isRateRemovable () {
      return this.$store.getters.getSource !== 'appear-here'
    },
  },
  methods: {
    async retrieveEstimate (payloadRE) {
      this.$store.commit('updateEstimateLoading', true)
      this.$store.commit('updateEstimate', null)

      const premises = this.$store.getters['premises/all']

      // delete products that don't have any rates
      payloadRE.products = payloadRE.products.filter(item => item.rates && item.rates.length > 0)

      for (const i in payloadRE.products) {
        for (const j in payloadRE.products[i].rates) {
          // omit rates without ratingInputs
          if (!payloadRE.products[i].rates[j].ratingInputs) continue

          if (payloadRE.products[i].rates[j].ratingInputs.employeeCount) { payloadRE.products[i].rates[j].ratingInputs.employeeCount = this.$store.getters.getEmployeeCount }

          if (payloadRE.products[i].rates[j].ratingInputs.industryId) { payloadRE.products[i].rates[j].ratingInputs.industryId = this.$store.getters.getIndustryId }

          if (payloadRE.products[i].rates[j].ratingInputs.turnover) { payloadRE.products[i].rates[j].ratingInputs.turnover = this.$store.getters.getTurnover }

          if (payloadRE.products[i].rates[j].ratingInputs.postcode) {
            payloadRE.products[i].rates[j].ratingInputs.postcode =
              premises.length > 0 && premises[0].postcode ? premises[0].postcode : ''
          }

          if (payloadRE.products[i].rates[j].ratingInputs.isValidBusiness) { payloadRE.products[i].rates[j].ratingInputs.postcode = this.$store.getters.getIsValidBusiness }
        }
      }

      // get products information
      const responseRE = await axiosRatingEngine.post(`api/products`, payloadRE)

      this.$store.commit('updateEstimateLoading', false)
      this.$store.commit('updateEstimate', responseRE.data)
    },
    async addRate (payload) {
      const data = payload.key.split('\\')
      const productKey = data[0]
      const rateKey = payload.key

      const product = this.getProduct(productKey)
      const rate = this.getRate(rateKey)

      // rate exists within quote - let's update
      if (rate) return this.updateRate(payload)

      const availableProduct = this.getAvailableProduct(productKey)
      const availableRate = this.getAvailableRate(rateKey)

      // rate is not available
      if (!availableRate) return

      // prepare payload
      const payloadRE = {
        products: [...cloneDeep(this.$store.state.products)],
      }

      if (!product) {
        payloadRE.products.push({
          key: availableProduct.key,
          rates: [],
        })
      }

      for (const i in payloadRE.products) {
        if (payloadRE.products[i].key === availableProduct.key) {
          payloadRE.products[i].rates.push({
            key: availableRate.key,
            ratingInputs: {
              ...payload,
            },
          })
        }
      }

      await this.retrieveEstimate(payloadRE)
    },
    async updateRate (payload) {
      const data = payload.key.split('\\')

      const productKey = data[0]
      const rateKey = payload.key

      const product = this.getProduct(productKey)

      if (!product) return this.addRate(payload)

      const rate = this.getRate(rateKey)

      // rate exists within quote - let's update
      if (!rate) return this.addRate(payload)

      const availableRate = this.getAvailableRate(rate.key)

      // rate is not available
      if (!availableRate) return

      const payloadRE = {
        products: [...cloneDeep(this.$store.state.products)],
      }

      for (const i in payloadRE.products) {
        if (payloadRE.products[i].key === product.key) {
          for (const j in payloadRE.products[i].rates) {
            if (payloadRE.products[i].rates[j].key === rate.key) {
              payloadRE.products[i].rates[j] = {
                key: availableRate.key,
                ratingInputs: {
                  ...payload,
                },
              }
            }
          }
        }
      }

      await this.retrieveEstimate(payloadRE)
    },
    async removeRate (rateKeys) {
      if (!Array.isArray(rateKeys)) rateKeys = [rateKeys]

      if (rateKeys.length === 0) return

      // when removing D&O remove EPL and Crime
      if (rateKeys.includes('ManagementLiability\\DirectorsAndOfficers')) {
        if (this.isRateActive('ManagementLiability\\EmploymentPracticesLiability')) { rateKeys.push('ManagementLiability\\EmploymentPracticesLiability') }

        if (this.isRateActive('ManagementLiability\\Crime')) rateKeys.push('ManagementLiability\\Crime')
      }

      // when removing any product remove LE if it's
      // the only product left and free LE coupon is not applied
      if (
        this.isRateActive('LegalExpenses\\LegalExpenses') &&
        this.$store.getters.getSelectedRatesIds.length === rateKeys.length + 1 &&
        !this.$store.getters.isCouponWithFreeLegalEntered &&
        !rateKeys.includes('LegalExpenses\\LegalExpenses')
      ) { rateKeys.push('LegalExpenses\\LegalExpenses') }

      const payloadRE = {
        products: [...this.$store.state.products],
      }

      for (const rateKey of rateKeys) {
        const data = rateKey.split('\\')
        const productKey = data[0]

        const product = this.getProduct(productKey)
        if (!product) continue

        const rate = this.getRate(rateKey)
        if (!rate) continue

        for (const i in payloadRE.products) {
          if (payloadRE.products[i].key === productKey) {
            for (const j in payloadRE.products[i].rates) {
              if (payloadRE.products[i].rates[j].key === rateKey) payloadRE.products[i].rates.splice(j, 1)

              if (payloadRE.products[i].rates.length === 0) payloadRE.products.splice(i, 1)
            }
          }
        }
      }

      await this.retrieveEstimate(payloadRE)
    },
    getRateComponent (key) {
      return components[key]
    },
    getAvailableRate (key) {
      const data = key.split('\\')
      const productKey = data[0]

      const product = this.getAvailableProduct(productKey)

      if (!product) return undefined

      for (const rate of product.rates) if (rate.key === key) return rate

      return undefined
    },
    getRate (key) {
      const data = key.split('\\')
      const productKey = data[0]

      const product = this.getProduct(productKey)

      if (!product) return undefined

      for (const rate of product.rates) if (rate.key === key) return rate

      return undefined
    },
    getRateContent (key) {
      return (
        this.$store.getters.getProductsContent[key] || {
          card_content: '',
          footer_content: '',
          more_info: '',
        }
      )
    },
    isRateAvailable (key) {
      return this.getAvailableRate(key) !== undefined
    },
    isRateOffered (key) {
      const rate = this.getAvailableRate(key)

      return rate && rate.isOffered === true
    },
    isRateActive (key) {
      return this.getRate(key) !== undefined
    },
    getProduct (productKey) {
      for (const product of this.$store.getters.getProducts) if (product.key === productKey) return product

      return undefined
    },
    getAvailableProduct (productKey) {
      for (const product of this.$store.getters.getAvailableProducts) if (product.key === productKey) return product

      return undefined
    },
    isProductAvailable: (state, getters) => (productKey) => {
      const products = getters.getAvailableProducts

      const product = products.find(x => x.key === productKey)

      return product !== undefined
    },
  },
}
